// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__CGPiT","description":"Sidebar_description___2PWl"};